import { Component, Input } from "@angular/core";
import { CommonModule } from "@angular/common";
import {
  resolveSidebarIconKey,
  SIDEBAR_ICONS,
} from "../sidebar-icons.registry";

@Component({
  selector: "app-sidebar-icon",
  standalone: true,
  imports: [CommonModule],
  template: `
    <svg
      [attr.width]="size"
      [attr.height]="size"
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      [attr.stroke-width]="strokeWidth"
      stroke-linecap="round"
      stroke-linejoin="round"
      class="sidebar-svg-icon"
      aria-hidden="true"
    >
      <path *ngFor="let d of paths" [attr.d]="d"></path>
    </svg>
  `,
  styles: [
    `
      :host {
        display: inline-flex;
        align-items: center;
        justify-content: center;
        line-height: 0;
      }
      .sidebar-svg-icon {
        display: block;
        flex-shrink: 0;
      }
    `,
  ],
})
export class SidebarIconComponent {
  @Input() name = "circle";
  @Input() size: number | string = 18;
  @Input() strokeWidth = 1.5;

  get paths(): string[] {
    const key = resolveSidebarIconKey(this.name);
    return SIDEBAR_ICONS[key] ?? SIDEBAR_ICONS["circle"];
  }
}
